import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TeambookProjectsPicker } from "../../default_components/TeambookDefaultPickers";
import { useProfileStore } from "../../../stores/profileStore";
import { shallow } from "zustand/shallow";
import PropTypes from "prop-types";
import TeambookDialog from "../../default_components/TeambookDialog";

const AddProjectsDialog = ({ setDialogOpened, projects, addProjects }) => {
  const { t } = useTranslation();
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [profile] = useProfileStore((state) => [state.profile], shallow);

  const closeModal = () => {
    setDialogOpened(false);
    setSelectedProjects([]);
  };

  const projectOptions = () => {
    if (profile.role === "self_planner") {
      return [...projects.filter((pr) => pr.kind === "time_off" && pr.capacity_counted).sort((x, y) => (x.name > y.name ? 1 : -1))];
    } else {
      return [
        ...projects.filter((pr) => pr.kind !== "time_off" && pr.capacity_counted).sort((x, y) => (x.name > y.name ? 1 : -1)),
        ...projects.filter((pr) => pr.kind === "time_off" && pr.capacity_counted).sort((x, y) => (x.name > y.name ? 1 : -1)),
      ];
    }
  };

  return (
    <TeambookDialog
      onClose={closeModal}
      title={t("planning.add_projects")}
      open={true}
      withCloseButton
      content={
        <TeambookProjectsPicker
          displayEmpty={true}
          projects={projectOptions()}
          defaultValue={[]}
          placeholder={"Select projects"}
          maxMenuHeight={150}
          type="multiple"
          onChange={(options) => {
            setSelectedProjects(Array.isArray(options) ? options : []);
          }}
          isSearchable={true}
        />
      }
      actionButtons={[
        {
          text: t("save"),
          onClick: () => {
            addProjects(selectedProjects);
            setSelectedProjects([]);
          },
        },
      ]}
    />
  );
};

AddProjectsDialog.propTypes = {
  setDialogOpened: PropTypes.func.isRequired,
  projects: PropTypes.array.isRequired,
  addProjects: PropTypes.func.isRequired,
};

export default AddProjectsDialog;
